import axios from 'axios';
import router from '../router';


const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};


const loginInterceptor = (config) => {
  // As the api for production and the frontend for staging are both running on
  // subdomains, we need to postfix the cookie, so each subdomain takes the
  // proper cookie and we do not mix them up
  let postfix = '';
  if (`${import.meta.env.VITE_API_COOKIE_POSTFIX}` !== "undefined") {
    postfix = `${import.meta.env.VITE_API_COOKIE_POSTFIX}`;
  }
  config.headers['X-CSRFToken'] = getCookie('csrftoken' + postfix);
  return config;
};

const userApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
  withCredentials: true,
});

const userApiUnprotected = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}unprotected`,
  withCredentials: true,
});

/**
 * Redirect to the login page when an authenticated route receives a 401.
 * The error is always rejected so callers never hang on a missing response.
 */
const unauthorizedInterceptor = (error) => {
  const isUnauthorized = error.response && error.response.status === 401;
  const requiresAuth = router.currentRoute.value?.meta?.requiresAuth;

  if (isUnauthorized && requiresAuth) {
    router.push({ name: 'login' });
  }

  return Promise.reject(error);
};

userApi.interceptors.response.use((response) => response, unauthorizedInterceptor);

userApiUnprotected.interceptors.response.use(
  (response) => response,
  unauthorizedInterceptor
);

userApi.interceptors.request.use(loginInterceptor);

export { userApi, userApiUnprotected };
